export const searchOptionsSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'searchOptions']);
export const fieldsSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'fields']);
export const ownersSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerList']);
export const ownerSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'owner']);
export const tagsSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'tagList']);
export const ownerTagsSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerTags']);
export const getCodefileOwnerTags = state =>
  state.getIn(['app', 'appraisal', 'owner', 'codeFileOwnerTags', 'data']);
export const notesSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'notes']);
export const propertiesSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'properties']);
export const ownerValidateSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerValidate']);
export const ownerSearchFilterFormSelector = state =>
  state.getIn(['form', 'appraisalOwnerSearch']);
export const ownerDetailFormSelector = state =>
  state.getIn(['form', 'appraisalOwnerDetail']);

// Owner lookup modal
export const ownerLookupModalOpenSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerLookupModal', 'open']);
export const ownerLookupModalModeSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerLookupModal', 'mode']);
export const ownerLookupModalStateSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerLookupModal', 'state']);
export const ownerLookupModalDataSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerLookupModal', 'data']);
export const ownerLookupModalRecordCountSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerLookupModal', 'count']);
export const ownerLookupModalSelectionSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerLookupModal', 'selection']);

// Owner create modal
export const ownerCreateModalOpenSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerCreateModal', 'open']);
export const ownerCreateModalResultSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerCreateModal', 'data']);

// Owner edit modal
export const ownerEditModalOpenSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerEditModal', 'open']);
export const ownerEditModalOwnerIdSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerEditModal', 'ownerId']);

// Ownership transfer >>>
export const ownershipTransferReturnUrl = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownershipTransferReturnUrl']);
export const propertyListingSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'owner',
    'ownershipTransfer',
    'propertyListing',
  ]);
export const propertyOwnersListingSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'owner',
    'ownershipTransfer',
    'propertyOwners',
  ]);

export const propertySellerOwnershipPctSelector = state =>
  state
    .getIn(['app', 'appraisal', 'owner', 'ownershipTransfer', 'sellerPcts'])
    .toJS();

export const ownershipTransferBuyersSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownershipTransfer', 'buyers']);

export const ownershipTransferOwnerExemptionsSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'owner',
    'ownershipTransfer',
    'ownerExemptionListing',
  ]);

export const ownerEventsSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'events']);

export const ownerGroupsSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerGroups']);

export const ownerAliasesSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerAliases', 'data']);
export const ownerAliasesStateSelector = state =>
  state.getIn(['app', 'appraisal', 'owner', 'ownerAliases', 'state']);
